/**
 * Expanded PDP helpers:
 * - Bundlr "Save 10%!" → trim trailing !
 * - Size pack pills: reset sliding-pill state after variant picker morph (2|5|10 ↔ 5|10)
 */
(function () {
  const root = document.getElementById('MainContent');
  if (!root) return;

  const savingsSelector =
    '.bndlr-quantity-break.bndlr-automatic-volume-bundle .bndlr-savings-text, ' +
    '.bndlr-quantity-break.bundler-volume-target-element .bndlr-savings-text';

  const sizeFieldsetSelector = '.variant-option:not(.variant-option--expanded-pdp-cards)';

  function stripTrailingBang() {
    for (const el of root.querySelectorAll(savingsSelector)) {
      const t = el.textContent;
      if (t && t.includes('%') && /!\s*$/.test(t)) {
        el.textContent = t.replace(/!\s*$/, '');
      }
    }
  }

  /** Clears theme pill-slide attrs so unchecked options do not flash a white sliding fill. */
  function resetSizePillState() {
    const picker = root.querySelector('variant-picker');
    if (!picker) return;

    for (const fieldset of picker.querySelectorAll(sizeFieldsetSelector)) {
      fieldset.style.removeProperty('--pill-width-current');
      fieldset.style.removeProperty('--pill-width-previous');

      for (const input of fieldset.querySelectorAll('input[type="radio"]')) {
        if (!(input instanceof HTMLInputElement)) continue;
        if (input.checked) {
          input.dataset.currentChecked = 'true';
          input.dataset.previousChecked = 'false';
        } else {
          input.dataset.currentChecked = 'false';
          input.dataset.previousChecked = 'false';
        }
      }
    }
  }

  let tId = 0;
  function scheduleMaintenance() {
    clearTimeout(tId);
    tId = setTimeout(() => {
      stripTrailingBang();
      resetSizePillState();
    }, 50);
  }

  stripTrailingBang();
  resetSizePillState();

  new MutationObserver(scheduleMaintenance).observe(root, {
    childList: true,
    subtree: true,
  });

  document.addEventListener('variant:update', resetSizePillState);
})();
